import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import lodash from 'lodash';
import { BOREHOLE_USERS } from '../../../../appConstants';

interface IBoreholeUserSelectorProps {
    value : string;

    onChange : (value : string) => void;
}

interface IBoreholeUserSelectorState {}

export default class BoreholeUserSelector extends React.Component<IBoreholeUserSelectorProps, IBoreholeUserSelectorState> {
    constructor(props : IBoreholeUserSelectorProps) {
        super(props);
        this.state = {};
    }

    private readonly onBoreholeUserChange = (event : React.ChangeEvent<{ name ?: string | undefined; value : unknown }>) => {
        if (typeof event.target.value !== 'string') return;
        this.props.onChange(event.target.value);
    };

    public readonly render = () => {
        const { value } = this.props;

        return (
            <React.Fragment>
                <div className={'flx1 ais p5 mb10 pr20'}>
                    <FormControl margin='normal' fullWidth>
                        <InputLabel shrink={!!value} htmlFor='value'>User</InputLabel>
                        <Select
                            fullWidth
                            id='value'
                            value={!value ? '' : value}
                            onChange={this.onBoreholeUserChange}>
                            <MenuItem value=''>
                                <em>None</em>
                            </MenuItem>
                            {
                                lodash.map(BOREHOLE_USERS, n => (
                                    <MenuItem key={`${n}_user`} value={`${n}`}>
                                        {n}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </div>
            </React.Fragment>
        );
    };
}
